import { connect } from 'react-redux';
import ReportSummary from './ReportSummary';

const mapStateToProps = (state: any) => ({
  details: state.singleDigitalGateway.details,
  appId: state.administration.apps.details.settings.settings.id,
  appName: state.administration.apps.details.settings.settings.attributes.name,
  configuration: state.singleDigitalGateway.integrations.configuration,
  isLoading: state.singleDigitalGateway.details.isLoading,
  failed: state.singleDigitalGateway.details.failed,
});

export default connect(
  mapStateToProps, null,
)(ReportSummary);
